import { Permission } from '@/lib/permissions/v1'
import {
    invoiceItemParamKey,
    invoiceParamKey,
    logParamKey,
    paymentItemParamKey,
} from '@/composables/route'

export enum FinanceInvoiceRouteName {
    Index = 'finance.invoices.index',
    Edit = 'finance.invoices.edit',
    EditItem = 'finance.invoices.items.edit',
    Show = 'finance.invoices.show',
    Items = 'finance.invoices.items',
    Logs = 'finance.invoices.logs',
    LogDetails = 'finance.invoices.logs.details',
    Send = 'finance.invoices.send',
    ItemLogs = 'finance.invoices.items.logs',
    ItemLogDetails = 'finance.invoices.items.logs.details',
    Payments = 'finance.invoices.payments',
    PaymentDetails = 'finance.invoices.payments.details',
}

export default {
    path: 'invoices',
    name: FinanceInvoiceRouteName.Index,
    component: () => import('@/views/finance/invoices/Index.vue'),
    meta: {
        label: 'Company Invoices',
        auth: true,
        permission: Permission.InvoiceViewAny,
    },
    children: [
        {
            path: `:${invoiceParamKey}/edit`,
            name: FinanceInvoiceRouteName.Edit,
            component: () => import('@/views/finance/invoices/Index.vue'),
            meta: {
                label: 'Edit Invoice',
                auth: true,
                permission: Permission.InvoiceUpdate,
            },
        },
        {
            path: `:${invoiceParamKey}/send`,
            name: FinanceInvoiceRouteName.Send,
            component: () => import('@/views/finance/invoices/Index.vue'),
            meta: {
                label: 'Send Invoice',
                auth: true,
                permission: Permission.InvoiceSend,
            },
        },
        {
            path: `:${invoiceParamKey}`,
            name: FinanceInvoiceRouteName.Show,
            component: () => import('@/views/finance/invoices/Index.vue'),
            meta: {
                label: 'Invoice Details',
                auth: true,
                permission: Permission.InvoiceView,
            },
            children: [
                {
                    path: 'items',
                    name: FinanceInvoiceRouteName.Items,
                    component: () => import('@/views/finance/invoices/Index.vue'),
                    meta: {
                        label: 'Invoice Items',
                        auth: true,
                        permission: Permission.InvoiceItemViewAny,
                    },
                    children: [
                        {
                            path: `:${invoiceItemParamKey}/edit`,
                            name: FinanceInvoiceRouteName.EditItem,
                            component: () => import('@/views/finance/invoices/Index.vue'),
                            meta: {
                                label: 'Edit Invoice Item',
                                auth: true,
                                permission: Permission.InvoiceItemUpdate,
                            },
                        },
                        {
                            path: `:${invoiceItemParamKey}/logs`,
                            name: FinanceInvoiceRouteName.ItemLogs,
                            component: () => import('@/views/finance/invoices/Index.vue'),
                            meta: {
                                label: 'Invoice Item Logs',
                                auth: true,
                                permission: Permission.EventViewAny,
                            },
                            children: [
                                {
                                    path: `:${logParamKey}`,
                                    name: FinanceInvoiceRouteName.ItemLogDetails,
                                    component: () => import('@/views/finance/invoices/Index.vue'),
                                    meta: {
                                        label: 'Log Details',
                                        auth: true,
                                        permission: Permission.EventView,
                                    },
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        {
            path: `:${invoiceParamKey}/logs`,
            name: FinanceInvoiceRouteName.Logs,
            component: () => import('@/views/finance/invoices/Index.vue'),
            meta: {
                label: 'Invoice Logs',
                auth: true,
                permission: Permission.EventViewAny,
            },
            children: [
                {
                    path: `:${logParamKey}`,
                    name: FinanceInvoiceRouteName.LogDetails,
                    component: () => import('@/views/finance/invoices/Index.vue'),
                    meta: {
                        label: 'Log Details',
                        auth: true,
                        permission: Permission.EventView,
                    },
                },
            ],
        },
        {
            path: `:${invoiceParamKey}/payments`,
            name: FinanceInvoiceRouteName.Payments,
            component: () => import('@/views/finance/invoices/Index.vue'),
            meta: {
                label: 'Invoice Payments',
                auth: true,
                permission: Permission.PaymentItemViewAny,
            },
            children: [
                {
                    path: `:${paymentItemParamKey}`,
                    name: FinanceInvoiceRouteName.PaymentDetails,
                    component: () => import('@/views/finance/invoices/Index.vue'),
                    meta: {
                        label: 'Payment Details',
                        auth: true,
                        permission: Permission.PaymentItemView,
                    },
                },
            ],
        },
    ],
}
